import flatten from 'lodash/flatten';
import uniq from 'lodash/uniq';

import type {
  DataStructureComponent,
  InfluencerMeta,
  List,
  RecentsMetaKey,
  RecentsResultEnhanced
} from 'types';

export const getUpdatedRecents = (
  recents: Array<DataStructureComponent>,
  influencerMeta: InfluencerMeta | undefined,
  metaKey: RecentsMetaKey,
  disableSelected: boolean = false
): Array<DataStructureComponent> => {
  const meta = influencerMeta?.[metaKey] || {};
  const keys = Object.keys(meta);

  let metaIds = keys.map(key => meta[key]);
  metaIds = uniq(flatten(metaIds));

  return recents.map(item => {
    if (metaIds.includes(Number(item.id))) {
      return {
        ...item,
        isSelected: true,
        isDisabled: disableSelected
      };
    }

    return item;
  });
};

export const enrichWithCurrentCollection = (
  items: Array<RecentsResultEnhanced>,
  list: List,
  influencerProfileId: number
): Array<RecentsResultEnhanced> => {
  const hasCurrentList = Boolean(list?.id);
  const alreadyHasCollection = items.some(item => item.id === list.id);

  if (alreadyHasCollection || !hasCurrentList) {
    return items;
  }

  return [
    {
      id: list.id,
      title: list.label,
      organizationId: list.organization.id,
      memberId: influencerProfileId
    },
    ...items
  ].slice(0, 4);
};
